"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookLineageCountsQueryWrapper = void 0;
var components_1 = require("@apollo/client/react/components");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var LineageCountsFunctions_1 = require("../lineage/LineageCountsFunctions");
function createUnfilteredCounts(data) {
    var _a, _b, _c;
    var workbook = data.workbooks && data.workbooks[0];
    if (workbook
        && workbook.upstreamDatabasesConnection
        && workbook.upstreamTablesConnection
        && workbook.upstreamFlowsConnection
        && workbook.upstreamDatasourcesConnection
        && workbook.sheetsConnection
        && workbook.dashboardsConnection
        && workbook.downstreamMetricsConnection
        && workbook.downstreamOwnersConnection) {
        return {
            filteredFieldName: null,
            upstreamDatabases: workbook.upstreamDatabasesConnection.totalCount,
            upstreamTables: workbook.upstreamTablesConnection.totalCount,
            upstreamVirtualConnections: ((_a = workbook.upstreamVirtualConnectionsConnection) === null || _a === void 0 ? void 0 : _a.totalCount) || 0,
            upstreamVirtualConnectionTables: ((_b = workbook.upstreamVirtualConnectionTablesConnection) === null || _b === void 0 ? void 0 : _b.totalCount) || 0,
            upstreamFlows: workbook.upstreamFlowsConnection.totalCount,
            upstreamDatasources: workbook.upstreamDatasourcesConnection.totalCount,
            upstreamLenses: ((_c = workbook.upstreamLensesConnection) === null || _c === void 0 ? void 0 : _c.totalCount) || 0,
            downstreamSheets: workbook.sheetsConnection.totalCount,
            downstreamDashboards: workbook.dashboardsConnection.totalCount,
            downstreamMetrics: workbook.downstreamMetricsConnection.totalCount,
            downstreamOwners: workbook.downstreamOwnersConnection.totalCount
        };
    }
    return null;
}
function createFilteredCounts(data) {
    var _a, _b, _c;
    var workbook = data.workbooks && data.workbooks[0];
    var embeddedDatasource = workbook && workbook.embeddedDatasources && workbook.embeddedDatasources[0];
    var filteredField = embeddedDatasource && embeddedDatasource.filteredFieldsConnection &&
        embeddedDatasource.filteredFieldsConnection.nodes[0];
    if (filteredField
        && filteredField.upstreamDatabasesConnection
        && filteredField.upstreamTablesConnection
        && filteredField.upstreamFlowsConnection
        && filteredField.upstreamDatasourcesConnection
        && filteredField.sheetsConnection
        && filteredField.dashboardsConnection
        && filteredField.downstreamMetricsConnection
        && filteredField.downstreamOwnersConnection) {
        return {
            filteredFieldName: (_a = filteredField === null || filteredField === void 0 ? void 0 : filteredField.name) !== null && _a !== void 0 ? _a : null,
            upstreamDatabases: filteredField.upstreamDatabasesConnection.totalCount,
            upstreamTables: filteredField.upstreamTablesConnection.totalCount,
            upstreamVirtualConnections: ((_b = filteredField.upstreamVirtualConnectionsConnection) === null || _b === void 0 ? void 0 : _b.totalCount) || 0,
            upstreamVirtualConnectionTables: ((_c = filteredField.upstreamVirtualConnectionTablesConnection) === null || _c === void 0 ? void 0 : _c.totalCount) || 0,
            upstreamFlows: filteredField.upstreamFlowsConnection.totalCount,
            upstreamDatasources: filteredField.upstreamDatasourcesConnection.totalCount,
            upstreamLenses: 0,
            downstreamSheets: filteredField.sheetsConnection.totalCount,
            downstreamDashboards: filteredField.dashboardsConnection.totalCount,
            downstreamMetrics: filteredField.downstreamMetricsConnection.totalCount,
            downstreamOwners: filteredField.downstreamOwnersConnection.totalCount,
        };
    }
    return null;
}
var WorkbookLineageCountsQueryWrapper = function (props) {
    var _a = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext), publishedConnectionsLineageEnabled = _a.publishedConnectionsLineageEnabled, lensLineageEnabled = _a.lensLineageEnabled;
    var keys = Object.keys(props.selectedKeys);
    if (keys.length > 0) {
        var selectedFieldId = keys[0];
        return (react_1.default.createElement(components_1.Query, { query: queries_1.WorkbookLineageCountsFilteredByFieldDocument, variables: {
                workbookVizportalUrlId: props.vizportalUrlId,
                selectedFieldId: selectedFieldId,
                selectedEmbeddedDatasourceId: props.selectedEmbeddedDatasourceId,
                publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled,
                lensLineageEnabled: lensLineageEnabled,
            } }, function (result) { return react_1.default.createElement(react_1.default.Fragment, null, (0, LineageCountsFunctions_1.renderFilteredLineageCounts)(result, createUnfilteredCounts, createFilteredCounts, props.children)); }));
    }
    else {
        return (react_1.default.createElement(components_1.Query, { query: queries_1.WorkbookLineageCountsDocument, variables: {
                workbookVizportalUrlId: props.vizportalUrlId,
                publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled,
                lensLineageEnabled: lensLineageEnabled,
            } }, function (result) { return react_1.default.createElement(react_1.default.Fragment, null, (0, LineageCountsFunctions_1.renderUnfilteredLineageCounts)(result, createUnfilteredCounts, props.children)); }));
    }
};
exports.WorkbookLineageCountsQueryWrapper = WorkbookLineageCountsQueryWrapper;
//# sourceMappingURL=WorkbookLineageCountsQueryWrapper.js.map